import { render, staticRenderFns } from "./BrandedCoinPreview.vue?vue&type=template&id=422f49ee&scoped=true&"
import script from "./BrandedCoinPreview.vue?vue&type=script&lang=ts&"
export * from "./BrandedCoinPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BrandedCoinPreview.vue?vue&type=style&index=0&id=422f49ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f49ee",
  null
  
)

export default component.exports